import React, { useState } from "react";
import { Alert, Button, Box } from "@mui/material";
import { OpenInNew, ZoomIn } from "@mui/icons-material";
import FullImageModal from "../widgets/FullImageModal";

export default function ReceiptPreview({ url }) {
  const [open, setOpen] = useState(false),
    [failed, setFailed] = useState(false);
  if (!url) return <Alert severity="info">No receipt has been uploaded for this order.</Alert>;
  const pdf = /\.pdf(?:[?#]|$)/i.test(url);
  return (
    <Box>
      <div className="tools-actions" style={{ marginBottom: 12 }}>
        <Button
          size="small"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<OpenInNew fontSize="small" />}
        >
          Open receipt file
        </Button>
        {!pdf && !failed && (
          <Button
            size="small"
            onClick={() => setOpen(true)}
            startIcon={<ZoomIn fontSize="small" />}
          >
            Enlarge
          </Button>
        )}
      </div>
      {pdf ? (
        <Alert severity="info">PDF receipt. Open the file to review the payment evidence.</Alert>
      ) : failed ? (
        <Alert severity="warning">Preview unavailable. Open the original file to review it.</Alert>
      ) : (
        <Box
          component="button"
          type="button"
          onClick={() => setOpen(true)}
          aria-label="Enlarge payment receipt"
          sx={{
            display: "block",
            width: "100%",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 2,
            bgcolor: "background.default",
            cursor: "zoom-in",
            p: 1,
          }}
        >
          <img
            src={url}
            alt="Payment receipt"
            onError={() => setFailed(true)}
            style={{ width: "100%", maxHeight: 280, objectFit: "contain", display: "block" }}
          />
        </Box>
      )}
      <FullImageModal open={open} handleClose={() => setOpen(false)} imgUrl={url} />
    </Box>
  );
}
